import { db } from "../../firebase";

const state = {
  nickname: "",
  gender: 0,
  dateOfBirth: "1990/1/1",
  height: 0
};

const mutations = {
  setNickname(state, payload) {
    state.nickname = payload;
  },
  setGender(state, payload) {
    state.gender = payload;
  },
  setDateOfBirth(state, payload) {
    state.dateOfBirth = payload;
  },
  setHeight(state, payload) {
    state.height = payload;
  },
  clear(state) {
    state.nickname = "";
    state.gender = "0";
    state.dateOfBirth = "1990/1/1";
    state.height = "0";
  }
};
const actions = {
  setNickname({ commit }, payload) {
    commit("setNickname", payload);
  },
  setGender({ commit }, payload) {
    commit("setGender", payload);
  },
  setDateOfBirth({ commit }, payload) {
    commit("setDateOfBirth", payload);
  },
  setHeight({ commit }, payload) {
    commit("setHeight", payload);
  },
  // Firebaseからユーザ情報を取得
  async fetchUserFromFirebase({ commit }, uid) {
    try {
      const snapshot = await db.ref(`/users/${uid}`).once("value");
      if (snapshot.val()) {
        const { nickname, gender, dateOfBirth, height } = snapshot.val();
        commit("setNickname", nickname);
        commit("setGender", gender);
        commit("setDateOfBirth", dateOfBirth);
        commit("setHeight", height);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseにユーザ情報を新規登録、上書き
  async sendUserToFirebase({ commit }, payload) {
    try {
      await db.ref(`/users/${payload.uid}`).update(payload.form);
      const { nickname, gender, dateOfBirth, height } = payload.form;
      if (nickname) commit("setNickname", nickname);
      if (gender) commit("setGender", gender);
      if (dateOfBirth) commit("setDateOfBirth", dateOfBirth);
      if (height) commit("setHeight", height);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを削除
  async deleteUserToFirebase({ commit }, uid) {
    try {
      await db.ref(`/users/${uid}`).update(null);
      commit("setNickname", "");
      commit("setGender", "0");
      commit("setDateOfBirth", "1990/1/1");
      commit("setHeight", "0");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  }
};
const getters = {
  getNickname: state => {
    return state.nickname;
  },
  getGender: state => {
    return state.gender;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
